/**
 * Check if any spacing values are set for a specific type and breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type {
	ResponsiveBreakpoint,
	SpacingAttributes,
	SpacingType,
} from '../../types';

/**
 * Check if any spacing values are set for a specific type and breakpoint
 */
export const hasSpacingValues = (
	attributes: SpacingAttributes,
	type: SpacingType,
	breakpoint: ResponsiveBreakpoint = 'desktop',
): boolean => {
	const breakpointData = attributes[ breakpoint ];
	const spacing = breakpointData?.[ type ];

	if ( ! spacing ) return false;

	return !! (
		spacing.top ||
		spacing.right ||
		spacing.bottom ||
		spacing.left
	);
};
